import API from '../helpers/interceptor';

export const getCompanies = () => API.get('/iod-master/companies');
export const getRegions   = () => API.get('/iod-master/regions');
export const getDealers   = () => API.get('/iod-master/dealers');
